import { Transition } from "@headlessui/react";
import {
  BriefcaseIcon,
  CogIcon,
  FolderIcon,
  HomeIcon,
  LocationMarkerIcon,
  LogoutIcon,
  MenuIcon,
  ShoppingBagIcon,
  UserGroupIcon,
  XIcon,
} from "@heroicons/react/outline";
import { useState } from "react";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { NavLink, useNavigate } from "react-router-dom";
import { useCart } from "react-use-cart";
import useAuth from "../hooks/useAuth";
import useLogout from "../hooks/useLogout";

const MenuMobile = () => {
  const { auth } = useAuth();
  const logout = useLogout();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { emptyCart } = useCart();

  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="flex lg:hidden">
      <button aria-label={t("Menu")} onClick={() => setMenuOpen(true)}>
        <MenuIcon aria-hidden="true" className="w-8" />
      </button>

      <Transition
        show={menuOpen}
        enter="transition-opacity duration-75"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-opacity duration-150"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <div className="fixed inset-0" onClick={() => setMenuOpen(false)}></div>

        <div className="bg-white fixed left-0 h-screen max-w-[90%] shadow-lg top-0 w-80 z-50">
          <div className="pt-12 px-6 relative">
            <button
              aria-label={t("Close")}
              className="absolute right-6 top-4"
              onClick={() => setMenuOpen(false)}
            >
              <XIcon aria-hidden="true" className="w-5" />
            </button>

            <div className="space-y-12">
              <div>
                <div className="border-yellow border-b-2 mb-4 pb-4">
                  <div className="font-medium text-xl">
                    {auth.customer.firstName} {auth.customer.lastName}
                  </div>
                  <div>{auth.customer.companyName}</div>
                </div>

                <button
                  className="flex font-medium items-center mt-2 text-lg"
                  onClick={() => {
                    emptyCart();

                    logout();

                    navigate("/login", { replace: true });

                    toast.success(t("Successfully logged out"));
                  }}
                >
                  <LogoutIcon className="mr-2 w-5" aria-hidden="true" />
                  <span>{t("Logout")}</span>
                </button>
              </div>

              <ul className="overflow-y-auto space-y-4">
                <li>
                  <NavLink
                    className="flex font-medium items-center text-lg"
                    onClick={() => setMenuOpen(false)}
                    to="/dashboard"
                  >
                    <HomeIcon className="mr-2 w-5" aria-hidden="true" />
                    <span>{t("Dashboard")}</span>
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    className="flex font-medium items-center text-lg"
                    onClick={() => setMenuOpen(false)}
                    to="/dashboard/orders"
                  >
                    <ShoppingBagIcon className="mr-2 w-5" aria-hidden="true" />
                    <span>{t("Orders")}</span>
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    className="flex font-medium items-center text-lg"
                    onClick={() => setMenuOpen(false)}
                    to="/dashboard/quotations"
                  >
                    <FolderIcon className="mr-2 w-5" aria-hidden="true" />
                    <span>{t("Quotations")}</span>
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    className="flex font-medium items-center text-lg"
                    onClick={() => setMenuOpen(false)}
                    to="/dashboard/company"
                  >
                    <BriefcaseIcon className="mr-2 w-5" aria-hidden="true" />
                    <span>{t("Company")}</span>
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    className="flex font-medium items-center text-lg"
                    onClick={() => setMenuOpen(false)}
                    to="/dashboard/addresses"
                  >
                    <LocationMarkerIcon
                      className="mr-2 w-5"
                      aria-hidden="true"
                    />
                    <span>{t("Addresses")}</span>
                  </NavLink>
                </li>

                {auth.customer.isAdmin ? (
                  <li>
                    <NavLink
                      className="flex font-medium items-center text-lg"
                      onClick={() => setMenuOpen(false)}
                      to="/dashboard/users"
                    >
                      <UserGroupIcon className="mr-2 w-5" aria-hidden="true" />
                      <span>{t("Users")}</span>
                    </NavLink>
                  </li>
                ) : null}

                <li>
                  <NavLink
                    className="flex font-medium items-center text-lg"
                    onClick={() => setMenuOpen(false)}
                    to="/dashboard/settings"
                  >
                    <CogIcon className="mr-2 w-5" aria-hidden="true" />
                    <span>{t("Settings")}</span>
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </Transition>
    </div>
  );
};

export default MenuMobile;
